import { Component, inject, OnInit } from '@angular/core';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { ClientsService } from '@app/pages/clients/services/clients.service';
import { environment } from '@env/environment.local';

@Component({
  template: ""
})
export class CustomerViewWrapperComponent {
  public readonly clientsService = inject(ClientsService);
  private readonly quoteService = inject(StandardQuoteService);
  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;

  customer: any | undefined = this.quoteService.formData?.customer;

  getTypeCustomer(personType: string | undefined): string {
    if (personType == 'LEGAL_PERSON') {
      return 'Persona moral';
    } else if (personType == 'NATURAL_PERSON') {
      return 'Persona física';
    }
    return '';
  }

  get personType() {
    return this.customer?.personType;
  }

  get name() {
    return this.customer?.firstName || this.customer?.customerName || "";
  }

  get lastName() {
    return this.customer?.lastName || '';
  }

  get mothersLastName() {
    return this.customer?.mothersLastName || '';
  }

  get rfc() {
    return this.customer?.rfc || '';
  }

  /** Solo lectura: `feriaCustomer` del cliente en la cotización. */
  customerFeriaReadonlyYesNo(): string {
    if (!this.featureLoyaltyFeriaQuotation) {
      return '';
    }
    const c = this.quoteService.formData?.customer ?? this.customer;
    return Boolean(c?.feriaCustomer) ? 'Sí' : 'No';
  }
}
